import { Link } from "react-router-dom";
import BlogPostLayout from "./BlogPostLayout";
import { getPostBySlug } from "../../lib/blog";

export default function DeratisationCreuse() {
  const post = getPostBySlug("deratisation-creuse-quand-faire-appel-professionnel");
  return (
    <BlogPostLayout post={post}>
      <p>
        La <strong>dératisation</strong> ne concerne pas seulement les grandes
        villes. En Creuse, les rats et souris sont fréquents en zone rurale,
        notamment dans les dépendances agricoles, granges, sous-sols et
        combles. Voici comment repérer une infestation et surtout{" "}
        <strong>quand appeler un professionnel</strong>.
      </p>

      <h2>Les signes d'une infestation en Creuse</h2>
      <ul>
        <li>
          <strong>Crottes</strong> le long des murs, dans les placards, greniers
          ou remises — noires et brillantes pour les rats, plus petites pour
          les souris.
        </li>
        <li>
          <strong>Bruits nocturnes</strong> dans les cloisons, faux plafonds ou
          combles (grattements, courses).
        </li>
        <li>
          <strong>Rongements</strong> visibles sur les sacs de nourriture, câbles
          électriques, portes en bois.
        </li>
        <li>
          <strong>Odeur d'urine</strong> caractéristique dans les caves ou
          celliers.
        </li>
        <li>
          <strong>Nids</strong> faits de papier, isolant ou tissus déchirés,
          souvent cachés derrière un frigo, dans une cheminée ou sous les
          combles.
        </li>
      </ul>

      <h2>Pourquoi ne pas tenter seul ?</h2>
      <p>
        Les tapettes et raticides du commerce ont trois limites majeures :
      </p>
      <ol>
        <li>
          <strong>Ils ne traitent pas la source.</strong> Vous éliminez
          quelques individus mais le nid continue de se reproduire ailleurs.
        </li>
        <li>
          <strong>Les rongeurs deviennent résistants.</strong> Depuis 10 ans,
          les études montrent une résistance croissante aux anticoagulants du
          commerce.
        </li>
        <li>
          <strong>Risque pour vos animaux domestiques et la faune sauvage</strong>
          (renards, rapaces qui mangent des rongeurs intoxiqués).
        </li>
      </ol>

      <div className="callout">
        <strong>À quel moment appeler un pro ?</strong>
        Dès que vous constatez plus de 2-3 signes ci-dessus, ou qu'un premier
        traitement en libre-service n'a rien donné en 15 jours. Chaque
        rongeuse peut avoir <strong>jusqu'à 60 petits par an</strong> —
        n'attendez pas.
      </div>

      <h2>Comment nous procédons</h2>
      <ol>
        <li>
          <strong>Diagnostic complet</strong> sur place : identification de
          l'espèce (rat brun, rat noir, souris grise, mulot), repérage des
          points d'entrée et des zones de nidification.
        </li>
        <li>
          <strong>Traitement raisonné</strong> avec des raticides homologués
          (biocides TP14) posés dans des postes sécurisés — pas de contact
          possible avec vos animaux domestiques.
        </li>
        <li>
          <strong>Colmatage des accès</strong> pour éviter la ré-infestation.
        </li>
        <li>
          <strong>Suivi et repositionnement</strong> des appâts jusqu'à
          disparition complète.
        </li>
      </ol>

      <h2>Combien ça coûte en Creuse ?</h2>
      <p>
        Le budget varie selon la surface et le degré d'infestation. À titre
        indicatif :
      </p>
      <ul>
        <li>
          <strong>Petite dératisation</strong> (maison, grenier ou cave) : à
          partir de <strong>80–150 €</strong>
        </li>
        <li>
          <strong>Grande dépendance ou plusieurs bâtiments</strong> :{" "}
          <strong>200–400 €</strong>
        </li>
        <li>
          <strong>Contrat annuel</strong> avec passages réguliers (professionnels,
          restaurants, exploitations agricoles) : sur devis
        </li>
      </ul>

      <h2>Zones fréquemment concernées</h2>
      <p>
        En Creuse, les zones à risque sont : les <strong>anciennes fermes</strong>{" "}
        et bâtiments agricoles, les habitations proches de{" "}
        <strong>silos ou de tas de bois</strong>, les <strong>combles isolés
        avec de la laine minérale</strong> (matériau apprécié des souris pour
        les nids), et les <strong>cuisines de gîtes ruraux</strong>.
      </p>

      <h2>Pour aller plus loin</h2>
      <p>
        Découvrez tous nos services sur la page{" "}
        <Link to="/entreprise-nuisibles-creuse">
          entreprise anti-nuisibles en Creuse
        </Link>
        , ou consultez notre article sur les{" "}
        <Link to="/conseils/chenilles-processionnaires-danger-traitement">
          chenilles processionnaires
        </Link>
        .
      </p>
    </BlogPostLayout>
  );
}
